module.exports = __webpack_public_path__ + "static/media/jnlpba.e102b0ae.png";